import React, { Component } from 'react';
import { Container, Row, Col, Form, Image, Button, Dropdown, DropdownButton,FormControl, Modal} from 'react-bootstrap';
import ReactNotification from 'react-notifications-component';
import NumberFormat from 'react-number-format';


import NavbarComponent from '../Navbar/index';
import RenovateTokenAlert from '../../RenovateToken';

import Backend from '../../Backend'
import Connection from '../../Calls'
import { store } from 'react-notifications-component';

import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import icons from '../Landing/icons.json'

import './Withdrawal.css'
import { Spinner } from 'react-activity';

import Warning from '../../Images/warning.svg'

export default class SettingIndex extends Component {
    constructor(props){
        super(props)
        this.state = {
            name: '',
            email:'',
            state: '',
            city: '',
            Biadd : '',
            PCode : '',
            BName : '',
            BInter : '',
            BAdd : '',
            BAcc : '',
            reference : '',
            Breference : '',
            swift : '',
            aba: '',
            spid: '',
            amount:0.00,
            balanceVirtual:'',
            balanceVirtualMXN: '',
            USDMXN:'',

            selectedCurrency:'usd',
            TWOfa:'',
            client_info:'',
            modalLoading:true,
            form_type:(this.props.data.location.state && this.props.data.location.state.form_type)?(this.props.data.location.state.form_type=='Card')&&this.props.traductions.Withdrawal.L_W_typeC:this.props.traductions.Withdrawal.L_W_typeB,

            type_requested:'',
            list_banks:[],
            pending_upgrade:'',
            accountSelected:{}
        }
    }

    componentDidMount(){
        this.get_balance_virtual()
        this.connectPricesSocket()
        this.getUserInfo()
        this.GetStatusCard()
        this.getPlanInfo();
    }

    GetStatusCard() {
        const self = this;

        let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
        navigator.geolocation.getCurrentPosition((success, error, options) => {
          latitude = success.coords.latitude;
          longitude = success.coords.longitude
        });
        result = latitude + longitude;
        Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
            var payload = response.payload

            Backend.GetStatusCard(localStorage.getItem('email'), localStorage.getItem('token'), response.payload.r01, response => {
            if (response.status.code === "0") {
              self.setState({
                statusCard:response.payload.card_status
              });

              if(response.payload.card_status === 'enabled')
                {
                    Backend.GetCardBalance(localStorage.getItem('email'), localStorage.getItem('token'), payload.r01, response => {
                        if (response.status.code === "0") {
                          self.setState({
                            bin:response.payload.bin
                          });
                        }
                      })
                }


            } else {
            }
          });
        });
    }

    get_balance_virtual() {
        const self = this;
        let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
        navigator.geolocation.getCurrentPosition((success, error, options) => {
        latitude = success.coords.latitude;
        longitude = success.coords.longitude
        });
        result = latitude + longitude;
        Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
        Backend.BalanceVirtualExchange(localStorage.getItem('email'), localStorage.getItem('token'), response.payload.r01, response => {
            if (response.status.code === "0") {
            self.setState({
                balanceVirtual: response.payload[0].balance,
                balanceVirtualMXN: response.payload[1].balance,
            });
            } else {
            store.addNotification({
                title: "Error!",
                message: response.status.description,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                duration: 1800,
                onScreen: true
                }
            });
            }
        });
        });
    }

    getUserInfo(){
        const self = this;
        let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
        navigator.geolocation.getCurrentPosition((success, error, options) => {
        latitude = success.coords.latitude;
        longitude = success.coords.longitude
        });
        result = latitude + longitude;
        Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
        var payload = response.payload
        Backend.GetUserInfo(localStorage.getItem('email'), localStorage.getItem('token'), payload.r01, response => {
            if(response.status.code == 0){
            this.setState({
                client_info:response.payload.client_info,
                name:response.payload.client_info.first_name+' '+response.payload.client_info.last_name,
                email:localStorage.getItem('email'),
            })
            if(response.payload.client_info.twofa_status === "enabled"){
                this.setState({TWOfa:true})
            }else{
                this.setState({TWOfa:false})
            }
            }

        });
        })
    }

    getPlanInfo(){
        let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";

        navigator.geolocation.getCurrentPosition((success, error, options) => {
        latitude = success.coords.latitude;
        longitude = success.coords.longitude
        });

        result = latitude + longitude;

        Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
            var payload = response.payload
            Backend.get_client_data(localStorage.getItem('email'), localStorage.getItem('token'), response.payload.r01, response => {
                if(response.status.code == '0'){
                    // setClientInfo(response.payload.client_info.type_requested)
                    this.setState({
                        type_requested:response.payload.client_info.type,
                        pending_upgrade:response.payload.client_info.pending_upgrade
                    })
                }
            });
            Backend.client_banks_list(localStorage.getItem('email'), localStorage.getItem('token'), 'all',response.payload.r01, response => {
                if(response.status.code == '0'){
                    // setBankList(response.payload.list_banks)
                    this.setState({
                        list_banks:response.payload.list_banks
                    })
                }
            });
        });
    }

    connectPricesSocket() {
        const self = this;

        var prices ;
        let flat=true;

        var wsProtocol = window.location.protocol === "https:" ? "wss:" : "ws:";
        var wsHost = window.location.hostname === "localhost" ? "50.116.20.64:8765" : window.location.host + "/ws/prices";
        var pricesSocket = new WebSocket(wsProtocol + "//" + wsHost);
        pricesSocket.onopen = function (event) {
        pricesSocket.send('GNTWIREBIT')
        }
        pricesSocket.onmessage = function (event) {
            try {
                var object = JSON.parse(event.data);
                self.setState({
                    USDMXN:object['USDMXN']
                })
            } catch (e) {}
        }
    }

    addNotification(result,msn,type){
        store.addNotification({
            title: result,
            message: msn,
            type:type,
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
            duration: 1800,
            onScreen: true
            }
        });
    }

    isEmpty(obj){
        return obj && Object.keys(obj).length === 0 && obj.constructor === Object
    }

    sendFiatWithdrawl(){
        const {selectedCurrency} = this.state
        const self = this;
        // && this.state.tagIdW !== ""
        self.setState({ showLoad: true });

        if (this.state.name !== "" && this.state.email !== ""  && this.state.amount != 0.00 && !this.isEmpty(this.state.accountSelected)) {
                window.scroll(0,0);
                let info={
                    "state":this.state.state ,
                    "city" : this.state.city ,
                    "billing_address" : this.state.Biadd,
                    "zip_code" : this.state.PCode,
                    "bank_name" : this.state.BName,
                    "bank_intermediary" : (this.state.BInter != '')?this.state.BInter:'-',
                    "bank_address" : this.state.BAdd,
                    "bank_account" : this.state.BAcc,
                    "reference" : this.state.reference,
                    "bank_reference" : this.state.Breference,
                    "swift_code" : (this.state.swift != '')?this.state.swift:'-',
                    "aba_code" : (this.state.aba != '')?this.state.aba:'-',
                }

                let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
                navigator.geolocation.getCurrentPosition((success, error, options) => {
                    latitude = success.coords.latitude;
                    longitude = success.coords.longitude
                });
                result = latitude + longitude;
                Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
                    Backend.FiatWithdrawl(localStorage.getItem('email'), localStorage.getItem('token'),Number(self.state.amount).toFixed(2) ,this.state.accountSelected.uuid, response.payload.r01, selectedCurrency, response => {
                    if (response.status.code === "0") {
                        self.addNotification( "Success!","Your withdrawal has been requested. It can take up to 5 natural days to be processed.","success")
                        this.setState({
                                        state: '',
                                        city: '',
                                        Biadd : '',
                                        PCode : '',
                                        BName : '',
                                        BInter : '',
                                        BAdd : '',
                                        BAcc : '',
                                        reference : '',
                                        Breference : '',
                                        swift : '',
                                        aba: '',
                                        spid:'',
                                        amount:0.00,
                                        USDMXN:'',
                                        accountSelected:{},
                                        })
                        self.get_balance_virtual()
                        self.setState({ showLoad: false });
                        window.scroll(0,0);
                    }else{
                        self.addNotification( "Error!",response.status.description,"danger")
                        self.setState({ showLoad: false });
                    }
                    })
                });
        } else {
            self.addNotification( "Error!","Verify information, fields cannot be empty","danger")
            self.setState({
                showLoad: false,
            });
        }
    }

    sendCardWithdrawal(){
        const {selectedCurrency} = this.state
        const self = this;
        // && this.state.tagIdW !== ""
        self.setState({ showLoad: true });

        if (this.state.amount != 0.00 ) {
            window.scroll(0,0);
            let info={
                "state" : '-',
                "city"  : '-',
                "billing_address"  : '-',
                "zip_code"  : '-',
                "bank_name"  : 'WIREBIT_BONE',
                "bank_intermediary"  : '-',
                "bank_address"  : '-',
                "bank_account"  : '-',
                "reference"  : '-',
                "bank_reference"  : '-',
                "swift_code"  : '-',
                "aba_code"  : '-',
            }

            let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
                navigator.geolocation.getCurrentPosition((success, error, options) => {
                    latitude = success.coords.latitude;
                    longitude = success.coords.longitude
                });
                result = latitude + longitude;
                Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
                    Backend.FiatWithdrawl(localStorage.getItem('email'), localStorage.getItem('token'),Number(self.state.amount).toFixed(2) , '-' , response.payload.r01, selectedCurrency, response => {
                    if (response.status.code === "0") {
                        self.addNotification( "Success!","Your withdrawal has been requested. It can take up to 5 natural days to be processed.","success")
                        this.setState({
                                        state: '',
                                        city: '',
                                        Biadd : '',
                                        PCode : '',
                                        BName : '',
                                        BInter : '',
                                        BAdd : '',
                                        BAcc : '',
                                        reference : '',
                                        Breference : '',
                                        swift : '',
                                        aba: '',
                                        amount:0.00,
                                        USDMXN:'',
                                        })
                        self.get_balance_virtual()
                        self.setState({ showLoad: false });
                        window.scroll(0,0);
                    }else{
                        self.addNotification( "Error!",response.status.description,"danger")
                        self.setState({ showLoad: false });
                    }
                    })
                });


        }else {

            self.addNotification( "Error!","Verify information, fields cannot be empty","danger")
            self.setState({
                showLoad: false,
            });
        }

    }

    renderBanksOptions(){
        return this.state.list_banks.map(item =>{
            if(item.status === "approved")
            return(
                <Dropdown.Item onClick={()=>
                    this.setState({
                        accountSelected: this.state.list_banks.find(bank => bank.uuid == item.uuid)
                    })
                } as="button"> {item.bank_number_account} </Dropdown.Item>
            )
        })
    }

    renderFiatForm(){
        const {selectedCurrency, balanceVirtual, balanceVirtualMXN} = this.state;
        let data=[]
        data.push(
            <>
                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Label className="virtual_exchange_information_wallets_text">{this.props.traductions.Withdrawal.L_name}</Form.Label>
                            <Form.Control style={{ height: 40 }} className="input-signup" type="text"  placeholder="Name" disabled value={this.state.name} onKeyPress={this.handleKeyPress} onChange={(name) => { this.setState({ name: name.target.value }) }} />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group>
                            <Form.Label className="virtual_exchange_information_wallets_text">{this.props.traductions.Withdrawal.L_email}</Form.Label>
                            <Form.Control style={{ height: 40 }}  className="input-signup" type="email" placeholder="example@mail.com" disabled value={this.state.email} onChange={(email) => { this.setState({ email: email.target.value }) }}/>
                        </Form.Group>
                    </Col>
                </Row>
                <Row style={{alignItems: "center"}}>
                    <Col>
                        <Form.Group>
                            <Form.Label className="virtual_exchange_information_wallets_text">{this.props.traductions.Withdrawal.L_Amount}</Form.Label>
                            <p className='availabletext'>{this.props.traductions.Withdrawal.L_Available}:${selectedCurrency === 'usd' ? balanceVirtual: balanceVirtualMXN} {selectedCurrency.toUpperCase()}</p>
                            <div className='containerAmount' style={{ display: "flex", alignItems: "center" }}>
                                <NumberFormat className='Amount-input' placeholder="USD Amount" decimalScale={2} thousandSeparator={true} prefix={'$'} value={this.state.amount} onValueChange={(amount) => { this.setState({ amount: amount.value }) }} />
                                <Button className={(this.state.selectedCurrency === 'usd') ?"boton-seleccionar-currency-selected" :"boton-seleccionar-currency"} variant="link" onClick={() => { this.setState({ selectedCurrency: 'usd' }) }}>USD</Button>
                                <Button className={(this.state.selectedCurrency === 'mxn') ?"boton-seleccionar-currency-selected" :"boton-seleccionar-currency"} variant="link" onClick={() => { this.setState({ selectedCurrency: 'mxn' }) }}>MXN</Button>
                            </div>
                            {
                                (this.state.selectedCurrency === 'mxn')
                                ? <p className='conversionMXN'>{this.props.traductions.Withdrawal.L_AmountNote} ${(this.state.USDMXN.bid)?(Number(this.state.amount)/Number(this.state.USDMXN.bid)).toFixed(2):Number(0.00).toFixed(2)} USD </p>
                                : <p className='conversionMXN'>{this.props.traductions.Withdrawal.L_AmountNote} ${(this.state.USDMXN.bid)?(Number(this.state.amount)*Number(this.state.USDMXN.bid)).toFixed(2):Number(0.00).toFixed(2)} MXN </p>
                            }

                        </Form.Group>
                    </Col>
                    <Col>
                      <div className='bank-transfer-notice'>
                        <Image src={Warning} style={{marginRight:10}}/>
                        <div className='bank-transfer-text'>
                            {this.state.selectedCurrency === "mxn" ? 
                                this.props.traductions.Withdrawal.L_note_mxn 
                                    : 
                                this.props.traductions.Withdrawal.L_note
                            }
                        </div>
                      </div>
                    </Col>
                </Row>
            </>
        )
        if(this.state.type_requested != 'free' && this.state.type_requested != ''){
            if(this.state.list_banks.every((value)=> value.status == 'pending') || this.state.list_banks.length <= 0){ // si la cuenta ya fue aprovada y no hay bancos o todos los bancos estan en pendiente
                data.push(
                    <div className='incompleteRecord'>
                        <p style={{margin:0}}>{this.props.traductions.Withdrawal.L_note_bk}.</p>
                        <p>{this.props.traductions.Withdrawal.L_note2_bk} <span className='link' onClick={()=>this.props.data.history.push({pathname: '/settings', state:{Tab:'Bank'}}) }>{this.props.traductions.General.registerResponse.click}</span></p>
                    </div>
                )
            }else{
                data.push(
                    <>
                        <hr />
                        <Row>
                            <Col className='virtual_exchange_dropdown'>
                                <DropdownButton className="" title={(!this.isEmpty(this.state.accountSelected))?this.state.accountSelected.bank_number_account: this.props.traductions.Withdrawal.L_selectBank} style={{marginBottom:10}}>
                                    {this.renderBanksOptions()}
                                </DropdownButton>
                            </Col>
                            <Col></Col>
                        </Row>

                        <Row className=''>
                            <Col lg={3} md={4} sm={12} >
                                <p>{this.props.traductions.settings.bank.bk_country}</p>
                                <p>  {(this.isEmpty(this.state.accountSelected ) || this.state.accountSelected.bank_country == '')? '-' : this.state.accountSelected.bank_country}  </p>
                            </Col>
                            <Col lg={3} md={4} sm={12} >
                                <p>{this.props.traductions.settings.bank.bk_state}</p>
                                <p>  {(this.isEmpty(this.state.accountSelected ) || this.state.accountSelected.state == '')? '-' : this.state.accountSelected.state}  </p>
                            </Col>
                            <Col lg={3} md={4} sm={12} >
                                <p>{this.props.traductions.settings.bank.bk_city}</p>
                                <p>  {(this.isEmpty(this.state.accountSelected ) || this.state.accountSelected.city == '')? '-' : this.state.accountSelected.city}  </p>
                            </Col>
                            <Col lg={3} md={4} sm={12} >
                                <p>{this.props.traductions.settings.bank.bk_zip}</p>
                                <p>  {(this.isEmpty(this.state.accountSelected ) || this.state.accountSelected.zip_code == '')? '-' : this.state.accountSelected.zip_code}  </p>
                            </Col>
                            <Col lg={3} md={4} sm={12} >
                                <p>{this.props.traductions.settings.bank.bk_address}</p>
                                <p>  {(this.isEmpty(this.state.accountSelected ) || this.state.accountSelected.bank_address == '')? '-' : this.state.accountSelected.bank_address}  </p>
                            </Col>
                            <Col lg={3} md={4} sm={12} >
                                <p>{this.props.traductions.settings.bank.bk_BillingAddss}</p>
                                <p>  {(this.isEmpty(this.state.accountSelected ) || this.state.accountSelected.billing_address == '')? '-' : this.state.accountSelected.billing_address}  </p>
                            </Col>
                            <Col lg={3} md={4} sm={12} >
                                <p>{this.props.traductions.settings.bank.bk_name}</p>
                                <p>  {(this.isEmpty(this.state.accountSelected ) || this.state.accountSelected.bank_name == '')? '-' : this.state.accountSelected.bank_name}  </p>
                            </Col>
                            <Col lg={3} md={4} sm={12} >
                                <p>{this.props.traductions.settings.bank.bk_currency}</p>
                                <p>  {(this.isEmpty(this.state.accountSelected ) || this.state.accountSelected.bank_currency == '')? '-' : this.state.accountSelected.bank_currency}  </p>
                            </Col>
                            <Col lg={3} md={4} sm={12} >
                                <p>{this.props.traductions.settings.bank.bk_accountNumber}</p>
                                <p>  {(this.isEmpty(this.state.accountSelected ) || this.state.accountSelected.bank_number_account == '')? '-' : this.state.accountSelected.bank_number_account}  </p>
                            </Col>
                            <Col lg={3} md={4} sm={12} >
                                <p>{this.props.traductions.settings.bank.bk_Intermediary}</p>
                                <p>  {(this.isEmpty(this.state.accountSelected ) || this.state.accountSelected.bank_intermediary == '')? '-' : this.state.accountSelected.bank_intermediary}  </p>
                            </Col>
                            <Col lg={3} md={4} sm={12} >
                                <p>{this.props.traductions.settings.bank.bk_CLABE}</p>
                                <p>  {(this.isEmpty(this.state.accountSelected ) || this.state.accountSelected.bank_clabe_account == '')? '-' : this.state.accountSelected.bank_clabe_account}  </p>
                            </Col>
                            <Col lg={3} md={4} sm={12} >
                                <p>SWIFT</p>
                                <p>  {(this.isEmpty(this.state.accountSelected ) || this.state.accountSelected.bank_swift == '')? '-' : this.state.accountSelected.bank_swift}  </p>
                            </Col>
                            <Col lg={3} md={4} sm={12} >
                                <p>SPID</p>
                                <p>  {(this.isEmpty(this.state.accountSelected ) || this.state.accountSelected.bank_spid == '')? '-' : this.state.accountSelected.bank_spid}  </p>
                            </Col>
                            <Col lg={3} md={4} sm={12} >
                                <p>ABA</p>
                                <p>  {(this.isEmpty(this.state.accountSelected ) || this.state.accountSelected.bank_aba == '')? '-' : this.state.accountSelected.bank_aba}  </p>
                            </Col>
                        </Row>

                        <center><Button onClick={()=>this.sendFiatWithdrawl()}>{this.props.traductions.Withdrawal.btn_send}</Button></center>
                    </>
                )
            }

        }else if(this.state.type_requested == 'free'){ // si la cuenta aun no es aprovada type == 'free'
            if(this.state.pending_upgrade == "True"){ // si la cuenta esta en proceso de ser aprovada
                data.push(
                    <div className='incompleteRecord'>
                        <p style={{margin:0}}>{this.props.traductions.General.registerResponse.revision}</p>
                    </div>
                )
            }else{  // no has llenado la informacion del form kyc
                data.push(
                    <div className='incompleteRecord'>
                        <p >{this.props.traductions.General.registerResponse.unregistered1}</p>
                        <p>{this.props.traductions.General.registerResponse.unregistered2} <span className='link' onClick={()=>this.props.data.history.push("/kyc") }>{this.props.traductions.General.registerResponse.click}</span></p>
                    </div>
                )
            }
        }
        return data;
    }

    renderCardForm(){
        const {selectedCurrency, balanceVirtual, balanceVirtualMXN} = this.state;
        return(
            <>
                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Label className="virtual_exchange_information_wallets_text">{this.props.traductions.Withdrawal.L_name}</Form.Label>
                            <Form.Control style={{ height: 40 }} className="input-signup" type="text"  placeholder="Name" disabled value={this.state.name} onKeyPress={this.handleKeyPress} onChange={(name) => { this.setState({ name: name.target.value }) }} />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group>
                            <Form.Label className="virtual_exchange_information_wallets_text">{this.props.traductions.Withdrawal.L_Card}</Form.Label>
                            <Form.Control style={{ height: 40 }}  className="input-signup" type="**** **** **** ****" placeholder="example@mail.com" disabled value={`**** **** **** *${this.state.bin}`} />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Label className="virtual_exchange_information_wallets_text">{this.props.traductions.Withdrawal.L_Amount}</Form.Label>
                            <p className='availabletext'>{this.props.traductions.Withdrawal.L_Available}:${selectedCurrency === 'usd' ? balanceVirtual: balanceVirtualMXN} {selectedCurrency.toUpperCase()}</p>
                            <div className='containerAmount' style={{ display: "flex", alignItems: "center" }}>
                                <NumberFormat className='Amount-input' placeholder="USD Amount" decimalScale={2} thousandSeparator={true} prefix={'$'} value={this.state.amount} onValueChange={(amount) => { this.setState({ amount: amount.value }) }} />
                                <Button className={(this.state.selectedCurrency === 'usd') ?"boton-seleccionar-currency-selected" :"boton-seleccionar-currency"} variant="link" onClick={() => { this.setState({ selectedCurrency: 'usd' }) }}>USD</Button>
                                <Button className={(this.state.selectedCurrency === 'mxn') ?"boton-seleccionar-currency-selected" :"boton-seleccionar-currency"} variant="link" onClick={() => { this.setState({ selectedCurrency: 'mxn' }) }}>MXN</Button>
                            </div>
                            {
                                (this.state.selectedCurrency === 'mxn')
                                ? <p className='conversionMXN'>{this.props.traductions.Withdrawal.L_AmountNote} ${ (this.state.USDMXN.bid)?(Number(this.state.amount)/Number(this.state.USDMXN.bid)).toFixed(2):Number(0.00).toFixed(2)} USD </p>
                                : <p className='conversionMXN'>{this.props.traductions.Withdrawal.L_AmountNote} ${ (this.state.USDMXN.bid)?(Number(this.state.amount)*Number(this.state.USDMXN.bid)).toFixed(2):Number(0.00).toFixed(2)} MXN </p>
                            }

                        </Form.Group>
                    </Col>
                    <Col>

                    </Col>
                </Row>
                <center><Button onClick={()=>this.sendCardWithdrawal()}>{this.props.traductions.Withdrawal.btn_send}</Button></center>
            </>
        )
    }

    render(){
        return(
            <div>
                <NavbarComponent data={this.props} selected="withdrawal" logged={true} />
                <RenovateTokenAlert data={this.props} />

                <div className="contenedor-wallets-generals">
                    <Container fluid>
                        <Row>
                            <Col lg={{span:10, offset:1}}>

                            <div className='contenedor-withdrawal'>
                                <div className='contenido-withdrawal'>
                                    {/* condicional render dropdown Fiat or Card */}
                                    {
                                        (this.state.statusCard === 'enabled')
                                        ?
                                            <div style={{display:'flex', justifyContent:'space-between', alignItems:'flex-end'}}>
                                                <Form.Group>
                                                    <Form.Label className="virtual_exchange_information_wallets_text">{this.props.traductions.Withdrawal.L_W_type}</Form.Label>
                                                    <DropdownButton className="virtual_exchange_dropdown" style={{ width:'15em'}}title={this.state.form_type}>
                                                        <Dropdown.Item onClick={() => { this.setState({ form_type: this.props.traductions.Withdrawal.L_W_typeB }) }}>{this.props.traductions.Withdrawal.L_W_typeB}</Dropdown.Item>
                                                        <Dropdown.Item onClick={() => { this.setState({ form_type: this.props.traductions.Withdrawal.L_W_typeC }) }}>{this.props.traductions.Withdrawal.L_W_typeC}</Dropdown.Item>
                                                    </DropdownButton>
                                                </Form.Group>
                                                <p>{this.props.traductions.Withdrawal.note}</p>
                                            </div>
                                        :
                                            <center><p>{this.props.traductions.Withdrawal.note2}</p></center>
                                    }

                                    {
                                        (this.state.form_type === this.props.traductions.Withdrawal.L_W_typeB ) ? this.renderFiatForm() : this.renderCardForm()
                                    }
                                </div>
                            </div>
                            </Col>
                        </Row>
                    </Container>
                </div>

                <Modal show={this.state.showLoad} centered aria-labelledby="contained-modal-title-vcenter" className='ModalShowLoad'>
                    <Spinner size={40} color={"#FFF"} animating={this.state.showLoad} />
                </Modal>
            </div>
        )
    }
}
